"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ExtraFiltersEnum_1 = __importDefault(require("@react/web/Listing/Filter/ExtraFiltersEnum"));
const PriceOfferList_1 = __importDefault(require("@react/web/Listing/ListingOffersList/CarListingItem/classes/PriceOfferList"));
const SimpleOfferList_1 = __importDefault(require("@react/web/Listing/ListingOffersList/CarListingItem/classes/SimpleOfferList"));
const WinterTiresFilterEnum_1 = __importDefault(require("@react/web/Listing/Filter/WinterTiresFilterEnum"));
class FilterByFormData {
    static filterOffers(filterFormData, carListingOffers, isMergedOffer) {
        let offers = FilterByFormData.createListingOffersCopy(carListingOffers);
        if (isMergedOffer === false) {
            offers = FilterByFormData.filterByMake(filterFormData, offers);
            offers = FilterByFormData.filterByModel(filterFormData, offers);
            offers = FilterByFormData.filterByBodyType(filterFormData, offers);
        }
        offers = FilterByFormData.filterByInquiryType(filterFormData, offers);
        offers = FilterByFormData.filterByContractLength(filterFormData, offers);
        offers = FilterByFormData.filterByMileage(filterFormData, offers);
        offers = FilterByFormData.filterByFuelType(filterFormData, offers);
        offers = FilterByFormData.filterByGearChanging(filterFormData, offers);
        offers = FilterByFormData.filterByAllWheelDrive(filterFormData, offers);
        offers = FilterByFormData.filterByWinterTires(filterFormData, offers);
        offers = FilterByFormData.filterByEquipment(filterFormData, offers);
        offers = FilterByFormData.filterByAvailability(filterFormData, offers);
        return offers;
    }
    static filterByMake(filterFormData, offers) {
        const activeFilterItems = filterFormData.getSelectedMakes();
        if (activeFilterItems.length === 0) {
            return offers;
        }
        return this.filterCarListingOffers(offers, (carListingOffer) => activeFilterItems.some((item) => item.value === carListingOffer.makeSlug));
    }
    static filterByModel(filterFormData, offers) {
        const activeFilterItems = filterFormData.getSelectedModels();
        if (activeFilterItems.length === 0) {
            return offers;
        }
        return this.filterCarListingOffers(offers, (carListingOffer) => activeFilterItems.some((item) => item.value === carListingOffer.modelSlug));
    }
    static filterByBodyType(filterFormData, offers) {
        const activeFilterItems = filterFormData.getSelectedBodyTypes();
        if (activeFilterItems.length === 0) {
            return offers;
        }
        return this.filterCarListingOffers(offers, (carListingOffer) => activeFilterItems.some((item) => item.value === carListingOffer.bodyType));
    }
    static filterByMileage(filterFormData, offers) {
        const activeFilterItems = filterFormData.getSelectedMileages();
        if (activeFilterItems.length === 0) {
            return offers;
        }
        return this.filterPriceOffers(offers, (priceOffer) => activeFilterItems.some((item) => priceOffer.mileageYearly >= Number(item.value)));
    }
    static filterByInquiryType(filterFormData, offers) {
        const activeFilterItems = filterFormData.getSelectedInquiryTypes();
        if (activeFilterItems.length === 0) {
            return offers;
        }
        return this.filterPriceOffers(offers, (priceOffer) => activeFilterItems.some((item) => priceOffer.assignedInquiryType === item.value));
    }
    static filterByContractLength(filterFormData, offers) {
        const activeFilterItems = filterFormData.getSelectedContractLengths();
        if (activeFilterItems.length === 0) {
            return offers;
        }
        return this.filterPriceOffers(offers, (priceOffer) => {
            if (priceOffer.contractLengths === null) {
                return false;
            }
            return priceOffer.contractLengths.filter((contractLength) => activeFilterItems.some((item) => String(contractLength.value) === item.value)).length > 0;
        });
    }
    static filterByFuelType(filterFormData, offers) {
        const activeFilterItems = filterFormData.getSelectedFuels();
        if (activeFilterItems.length === 0) {
            return offers;
        }
        return this.filterSimpleOffers(offers, (simpleOffer) => activeFilterItems.some((item) => item.label === simpleOffer.powertrain.filterFuelType));
    }
    static filterByGearChanging(filterFormData, offers) {
        if (filterFormData.isSelectedExtrasGearChanging() === false) {
            return offers;
        }
        return this.filterSimpleOffers(offers, (simpleOffer) => simpleOffer.powertrain.gearChanging.toLowerCase() === ExtraFiltersEnum_1.default.automat);
    }
    static filterByAllWheelDrive(filterFormData, offers) {
        if (filterFormData.isSelectedExtrasAllWheelDrive() === false) {
            return offers;
        }
        return this.filterSimpleOffers(offers, (simpleOffer) => simpleOffer.powertrain.isFourWheelDrive === true);
    }
    static filterByWinterTires(filterFormData, offers) {
        const activeFilterItems = filterFormData.getSelectedWinterTires();
        if (activeFilterItems.length === 0) {
            return offers;
        }
        return this.filterSimpleOffers(offers, (simpleOffer) => activeFilterItems.some((item) => simpleOffer.hasWinterTires === (item.value === WinterTiresFilterEnum_1.default.included)));
    }
    static filterByEquipment(filterFormData, offers) {
        let filteredOffers = offers;
        filterFormData.equipment.forEach((item) => {
            if (item.active) {
                filteredOffers = offers.filter((carListingOffer) => {
                    carListingOffer.simpleOfferList.simpleOffers = carListingOffer.simpleOfferList.simpleOffers.filter((simpleOffer) => (item.id ? simpleOffer.equipments.includes(item.id) : false));
                    return carListingOffer.simpleOfferList.getCount() > 0;
                });
            }
        });
        return filteredOffers;
    }
    static filterByAvailability(filterFormData, offers) {
        const activeFilterItems = filterFormData.getSelectedAvailabilities();
        if (activeFilterItems.length === 0) {
            return offers;
        }
        return this.filterSimpleOffers(offers, (simpleOffer) => activeFilterItems.some((item) => simpleOffer.availabilityDescription === (item.label)));
    }
    static createListingOffersCopy(listingOffers) {
        return listingOffers.map((carListingOffer) => {
            const simpleOffers = carListingOffer.simpleOfferList.simpleOffers.map((simpleOffer) => (Object.assign(Object.assign({}, simpleOffer), { priceOfferList: new PriceOfferList_1.default([
                    ...simpleOffer.priceOfferList.priceOffers,
                ]) })));
            return Object.assign(Object.assign({}, carListingOffer), { simpleOfferList: new SimpleOfferList_1.default(simpleOffers) });
        });
    }
    static filterCarListingOffers(offers, callback) {
        return offers.filter((carListingOffer) => callback(carListingOffer));
    }
    static filterSimpleOffers(offers, callback) {
        return this.filterCarListingOffers(offers, (carListingOffer) => {
            carListingOffer.simpleOfferList.simpleOffers = carListingOffer.simpleOfferList.simpleOffers.filter((simpleOffer) => callback(simpleOffer));
            return carListingOffer.simpleOfferList.getCount() > 0;
        });
    }
    static filterPriceOffers(offers, callback) {
        return this.filterSimpleOffers(offers, (simpleOffer) => {
            simpleOffer.priceOfferList.priceOffers = simpleOffer.priceOfferList.priceOffers.filter((priceOffer) => callback(priceOffer));
            return simpleOffer.priceOfferList.getCount() > 0;
        });
    }
}
exports.default = FilterByFormData;
